// extracted by mini-css-extract-plugin
export default {"truncate":"SpotlightTitle_truncate__30BOb"};